const URLAPI = process.env.REACT_APP_BASE_URL;

export async function fetchGetConections() {
  const response = await fetch(
    `${URLAPI}/Auth/GetConections`,
    {
      method: "GET", headers: {
        'Content-Type': 'application/json',
      },
    }
  );

  const data = await response.json();
  return data;
}